import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SEO from 'SEO';

import Layout from 'components/layout';
import Banner from 'components/banner';
import ContentNavigation from 'components/navigation';
import SideBarWidget from 'components/widgets';
import Button from 'components/buttons/Main';

import RenderRichText from 'utils/richText/renderRichText';

import { ColumnLarge, FullWidthTwoColumnContainer, StyledSidebarColumn } from 'components/grid/styled';

import { setPhoneNumber } from 'state/actions/phoneNumber';

const RenderPostWrapper = props => {
  let bannerImageSrc;
  let bannerImageSize;
  let textPosition;
  let headingOneRichText;
  let headingTwoRichText;
  let headingThreeRichText;
  let paragraphRichText;

  const [ headingOneText, setHeadingOneText ] = useState("");
  
  const { 
    setPhoneNumber, 
    phoneNumber,
    isAircraftTemplate,
    keyFeaturesWidget,
    bannerImageSlice,
    widget,
    preview,
    showFlightSearchWidget,
    aircraftName,
    keyFeaturesText,
    tableOfContentsSlice,
  } = props;

  useEffect(() => {
    if (isAircraftTemplate) {
      const headingOne = document.querySelector("article h1");
    
      if (headingOne) {
        headingOne.remove()
        headingOne.style.display = "none"
        setHeadingOneText(headingOne.textContent.replace("- Private Jet Charter", "").replace("Charter an", "").replace("Charter a", ""))
      }
    }

    setPhoneNumber(phoneNumber)
  }, [])

  // Banner Data
  if (bannerImageSlice) {
    const headingOneData = bannerImageSlice.primary.heading1;
    const headingTwoData = bannerImageSlice.primary.heading2;
    const headingThreeData = bannerImageSlice.primary.heading3;
    const paragraphData = bannerImageSlice.primary.banner_text;
    
    bannerImageSrc = bannerImageSlice.primary.image.url
    bannerImageSize = bannerImageSlice.primary.banner_image_size;
    textPosition = bannerImageSlice.primary.text_position;
    // check if banner heading 1-3 and paragraph data exists and is not empty
    headingOneRichText = headingOneData ? headingOneData.length > 0 && preview ? headingOneData : headingOneData.raw : [];
    headingTwoRichText = headingTwoData ? headingTwoData.length > 0 && preview ? headingTwoData : headingTwoData.raw : [];
    headingThreeRichText = headingThreeData ? headingThreeData.length > 0 && preview ? headingThreeData : headingThreeData.raw: [];
    paragraphRichText = paragraphData ? paragraphData.length > 0 && preview ? paragraphData : paragraphData.raw : [];

  } else if (props.heroImage && props.heroImage.url) {
    bannerImageSrc = props.heroImage.url
  } else {
    bannerImageSrc = props.defaultBannerImage.url
  }

  // // Widget Check
  const hasWidget = widget && widget.length > 0;

  return (
    <Layout
      location={props.location}
      language={props.language}
      alternateLanguages={props.alternateLanguages}
      localePhoneNumber={props.localePhoneNumber}
      universalProps={props.universalProps}
      errorMessages={props.errorMessages}
      icons={props.icons}
      footerProps={props.footerProps}
      headerData={props.headerData}
      preview={preview}
      previewHeaderData={props.headerData}
      previewFooterData={props.footerProps.node}
    >
      <SEO 
        meta={props.meta}
        location={props.location}
        language={props.language}
        alternateLanguages={preview ? [] : props.alternateLanguages}
        genericAirfield={props.genericAirfield}
        languageCodes={props.languageCodes}
        preview={preview}
        isBlog={props.isBlog}
        fsExcludeFlag={props.fsExcludeFlag}
        phoneNumber={phoneNumber}
      />

      <Banner 
        desktopLarge={false}
        desktopMedium={true}
        desktopSmall={false}
        isHomePage={false}
        headingOne={headingOneRichText ? <RenderRichText richTextArray={headingOneRichText} /> : isAircraftTemplate && <h1>{headingOneText}</h1>}
        headingTwo={headingTwoRichText && <RenderRichText richTextArray={headingTwoRichText} />}
        headingThree={headingThreeRichText && headingThreeRichText && <RenderRichText richTextArray={headingThreeRichText} />}
        isTemplate={true}
        bannerImageSrc={bannerImageSrc}
        textPosition={textPosition}
        bannerImageSize={bannerImageSize}
      />

      { tableOfContentsSlice && tableOfContentsSlice.length > 0 && (
        <ContentNavigation 
          anchors={tableOfContentsSlice[0].items || tableOfContentsSlice } 
          isTwoColumnLayout={true}
          isAircraftTemplate={isAircraftTemplate}
        />  
      )}

      <FullWidthTwoColumnContainer justifyContent="space-between">
        
        <ColumnLarge width={props.columnWidth} maxWidth={props.maxColLargeWidth}>
          {props.component}
        </ColumnLarge>

        <StyledSidebarColumn 
          hasWidget={widget && widget.length > 0}
          isAircraftTemplate={isAircraftTemplate && (keyFeaturesWidget || keyFeaturesText)}
        >

          { showFlightSearchWidget && hasWidget ? (
            <React.Fragment>

              { widget.map(el => {
                  const widgetData = preview ? el.data : el.primary.widget_document.document[0].data;
                  const widgetType = widgetData.widget_type;
                  const widgetButtonText = widgetData.widget_button_text;     
                  const widgetButtonLink = widgetData.widget_button_link.url;

                  return (
                    <SideBarWidget 
                      preview={preview}
                      widgetType={widgetType}
                      widgetData={widgetData} 
                      swissPhoneNumber={phoneNumber}
                      buttonComponent={
                        <Button 
                          className="widget-cta-button"
                          isLink={true}
                          size="large"
                          buttonText={widgetButtonText}
                          buttonHref={widgetButtonLink}
                          margin="0"
                          width="100%"
                        />
                      }
                    />
                  )

                })
              }
              
            </React.Fragment>

            ) : isAircraftTemplate ? (

              <React.Fragment>

                <SideBarWidget 
                  widgetType="key features"
                  preview={preview}
                  isFrench={process.env.LANG_CODE === 'fr-fr' || props.language === 'fr-fr'}
                  widgetData={keyFeaturesWidget?.primary} 
                  buttonComponent={null}
                  isAircraftTemplate={true}
                  swissPhoneNumber={phoneNumber}
                  aircraftName={!keyFeaturesWidget && aircraftName}
                  keyFeaturesText={!keyFeaturesWidget && keyFeaturesText}
                  hasPurpleCTAWidgetBelow={ 
                    hasWidget && widget.length > 0 && widget.find(el => el.data.widget_type === 'purple call to action widget') 
                  }
                />

                {hasWidget && widget?.length > 0 && (
                  widget?.map(el => {
                    const widgetData = el.data;
                      const widgetType = widgetData.widget_type;
                      const widgetButtonText = widgetData.widget_button_text;     
                      const widgetButtonLink = widgetData.widget_button_link.url;
        
                      return (
                        <SideBarWidget 
                          preview={preview}
                          widgetType={widgetType}
                          widgetData={widgetData} 
                          swissPhoneNumber={phoneNumber}
                          buttonComponent={
                            <Button 
                              className="widget-cta-button"
                              isLink={true}
                              size="large"
                              buttonText={widgetButtonText}
                              buttonHref={widgetButtonLink}
                              margin="0"
                              width="100%"
                            />
                          }
                        />
                      )
                    })
                  )
                }
              </React.Fragment>
            
            ) : ( 
            
            widget?.map(el => {
              const widgetData = preview ? el.data : el.primary.widget_document.document[0].data;
              const widgetType = widgetData.widget_type;
              const widgetButtonText = widgetData.widget_button_text;     
              const widgetButtonLink = widgetData.widget_button_link.url;

              return (
                <SideBarWidget 
                  preview={preview}
                  widgetType={widgetType}
                  widgetData={widgetData} 
                  swissPhoneNumber={phoneNumber}
                  buttonComponent={
                    <Button 
                      className="widget-cta-button"
                      isLink={true}
                      size="large"
                      buttonText={widgetButtonText}
                      buttonHref={widgetButtonLink}
                      margin="0"
                      width="100%"
                    />
                  }
                />
              )
            })
          )}
        </StyledSidebarColumn>
      </FullWidthTwoColumnContainer>
    </Layout>
  );
};

const mapDispatchToProps = dispatch => ({
  setPhoneNumber: phoneNumber => dispatch(setPhoneNumber(phoneNumber))
})

export default connect(null, mapDispatchToProps)(RenderPostWrapper);

RenderPostWrapper.propTypes = {
  aircraftName: PropTypes.string,
  alternateLanguages: PropTypes.array,
  bannerImageSlice: PropTypes.object,
  columnWidth: PropTypes.string,
  component: PropTypes.object,
  defaultBannerImage: PropTypes.object,
  errorMessages: PropTypes.array,
  footerProps: PropTypes.object,
  fsExcludeFlag: PropTypes.number,
  genericAirfield: PropTypes.string,
  headerData: PropTypes.object,
  heroImage: PropTypes.object,
  icons: PropTypes.array,
  isAircraftTemplate: PropTypes.bool,
  isBlog: PropTypes.bool,
  keyFeaturesText: PropTypes.string,
  keyFeaturesWidget: PropTypes.object,
  language: PropTypes.string,
  languageCodes: PropTypes.array,
  localePhoneNumber: PropTypes.array,
  location: PropTypes.object,
  maxColLargeWidth: PropTypes.string,
  meta: PropTypes.object,
  phoneNumber: PropTypes.string,
  preview: PropTypes.bool,
  setPhoneNumber: PropTypes.func,
  showFlightSearchWidget: PropTypes.bool,
  tableOfContentsSlice: PropTypes.array,
  universalProps: PropTypes.array,
  widget: PropTypes.array,
}
